import { makeStyles } from '@material-ui/core'
import { DRAWER_WIDTH } from '../neo-wrapper.styles'

const useNeoWrapperDrawerStyles = makeStyles((theme) => ({
    drawer: {
        width: DRAWER_WIDTH,
        flexShrink: 0
    },
    drawerPaper: {
        width: DRAWER_WIDTH
    },
    toolbar: {
        display: 'flex',
        height: '65px',
        padding: '24px 16px 16px',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex - start',
        flexShrink: 0,
        alignSelf: 'stretch',
        boxSizing: 'border-box',
        margin: 0
    },
    content: {
        paddingTop: '16px',
        display: 'flex',
        flexFlow: 'column nowrap',
        flexGrow: 1,
        flexShrink: 0
    },
    footer: {
        display: 'flex',
        paddingLeft: theme.spacing(2),
        paddingBottom: theme.spacing(2)
    },
    footerLink: {
        fontFamily: 'var(--font-family-base)',
        fontSize: '0.8125rem',
        letterSpacing: 0,
        color: '#007DB8'
    },
    logo: {
        width: '200px',
        height: '25px',
        flexShrink: 0,
        display: 'block'
    },
    footerPrivacyChoicesImage: {
        width: '30px',
        paddingLeft: '5px'
    }
}))

export default useNeoWrapperDrawerStyles
